<umkt-auth-layout scrollable>
  <div class="auth-card-content">
    <div class="auth-card-form">
      <div class="auth-intern-form">
        <div class="auth-title">
          <h1 class="title-text font-highlight">
            {{ 'pages.externalChannelAccess.title' | i18n }}
          </h1>
          <p class="subtitle-text">
            {{ 'pages.externalChannelAccess.subtitle' | i18n }}
          </p>
        </div>

        <umkt-loading
          *ngIf="loading"
          [isLoading]="true"
          [size]="'md'"
          [mode]="'contained'"
          [showText]="true"
          [text]="'shared.messages.loading' | i18n"
        ></umkt-loading>
      </div>
    </div>
  </div>
</umkt-auth-layout>

